import { type ReactNode } from 'react';
import { cn } from '../../lib/utils';

type Color = 'cyan' | 'emerald' | 'amber' | 'rose' | 'slate';

const COLORS: Record<Color, string> = {
  cyan: 'text-cyan-700 dark:text-cyan-300 bg-cyan-500/10 border-cyan-500/20',
  emerald: 'text-emerald-700 dark:text-emerald-300 bg-emerald-500/10 border-emerald-500/20',
  amber: 'text-amber-700 dark:text-amber-300 bg-amber-500/10 border-amber-500/20',
  rose: 'text-rose-700 dark:text-rose-300 bg-rose-500/10 border-rose-500/20',
  slate: 'text-slate-600 dark:text-slate-300 bg-slate-500/10 border-slate-500/20',
};

interface BadgeProps {
  color?: Color;
  children: ReactNode;
  className?: string;
}

export function Badge({ color = 'slate', children, className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-medium border',
        COLORS[color],
        className,
      )}
    >
      {children}
    </span>
  );
}
